module.exports = __webpack_public_path__ + "static/media/24UHCHR3.8962b857.jpg";